import Icons from "assets/icons";
import React, {useEffect, useState} from "react";
import {columns, fields as fieldsInit} from "./config";
import {useAppSelector} from "redux/hooks";
import {useDispatch} from "react-redux";
import {allocationMedicineService, catalogMedicineStoreService} from "api";
import TableInputAdd from "./TableInputAdd/TableInputAdd";
import {InputFields} from "components/common";
import {Button, Form, Row, Spin, message} from "antd";
import {
  convertIosStringToDate,
  convertIosStringToDate2,
  formatDateToString,
} from "helper/common";
import {tabKeys} from "types/enums";
import {setActiveTabAllocation} from "redux/reducer/allocationMedicine";
import Notification from "components/common/notification/notification";
const Detail = () => {
  const dispatch = useDispatch();
  const [form] = Form.useForm();
  const activeTabAllocation = useAppSelector(
    state => state.allocationMedicine.activeTabAllocation
  );
  const activeTab = useAppSelector(state => state.common.activeTab);
  const [khoUserId, setKhoUserId] = useState<any>(1);
  const [loading, setLoading] = useState(false);
  const selectedRecord = useAppSelector(
    state => state.allocationMedicine.selectedRecord
  );
  const [disabled, setDisabled] = useState(false);
  const [data, setData] = useState<any[]>([]);
  const [fields, setFields] = useState<any[]>(fieldsInit);
  useEffect(() => {
    if (activeTabAllocation == tabKeys.MEDICINE_STORE.ALLOCATION_DETAIL) {
      if (selectedRecord?.status == "CB") {
        const khoId = Number(localStorage.getItem("khoUserId"));
        setKhoUserId(khoId);
        form.setFieldValue("storeId", khoId);
      }
    }
  }, [activeTabAllocation, activeTab]);

  useEffect(() => {
    getListStore();
  }, []);
  useEffect(() => {
    if (activeTabAllocation != tabKeys.MEDICINE_STORE.ALLOCATION_DETAIL) {
      setData([]);
    } else {
      setDataTable(selectedRecord);
    }
  }, [activeTabAllocation]);
  useEffect(() => {
    if (selectedRecord) {
      setFormValue(selectedRecord);
      setDataTable(selectedRecord);
    }
  }, [selectedRecord]);
  const setDataTable = selectedRecord => {
    if (selectedRecord) {
      if (selectedRecord?.status == "DB") {
        setData(selectedRecord?.listPrescriptionSalesDto);
        setDisabled(true);
      } else {
        setData(selectedRecord?.listPrescriptionDetailDto);
        setDisabled(false);
      }
    }
  };
  const getListStore = async () => {
    try {
      const res = await catalogMedicineStoreService.getListStore(1, 20);
      fieldsInit.find(e => e.name == "storeId").options = res.data.map(e => ({
        value: e.id,
        label: e.name,
      }));
      setFields([...fieldsInit]);
    } catch (error) {}
  };
  const setFormValue = formValue => {
    const formatValue = {
      ...formValue,
      ngaySinh: convertIosStringToDate(formValue.ngaySinh),
      thoiGianKham: convertIosStringToDate2(formValue.thoiGianKham),
    };
    form.setFieldsValue(formatValue);
  };
  const allocation = async () => {
    const isValid = validateListMedicine();
    if (isValid) {
      try {
        setLoading(true);
        const params = getDetailPrescription();

        await allocationMedicineService.allocationMedicine(params);
        Notification(
          "success",
          `Đã cấp phát đơn thuốc mã ${selectedRecord?.donKeId}`
        );
        setLoading(false);
        dispatch(
          setActiveTabAllocation(tabKeys.MEDICINE_STORE.ALLOCATION_LIST)
        );
      } catch (error) {
        Notification("error", `${error?.response?.data}`);
        setLoading(false);
      }
    }
  };
  const getDetailPrescription = () => {
    const prescriptionDto = {
      ...selectedRecord,
      ...form.getFieldsValue(),

      listPrescriptionSalesDto: [],
      listPrescriptionDetailDto: [],
    };

    const listPrescriptionSalesDto = data.map(e => ({
      ...e,
      hanSuDung: formatDateToString(e.hanSuDung, null),
    }));
    const params = {
      prescriptionDto: prescriptionDto,
      listPrescriptionSalesDto: listPrescriptionSalesDto,
    };
    return params;
  };
  const validateListMedicine = () => {
    let isValid = true;
    const listKey = {
      ["soLo"]: "số lô",
      ["soLuongCapPhat"]: "số lượng cấp phát",
    };
    data.forEach((e, index) => {
      let listInvalidKey = [];
      Object.keys(listKey).map(key => {
        if (e[key] == null) {
          listInvalidKey.push(listKey[key]);

          isValid = false;
        }
      });
      if (listInvalidKey.length > 0) {
        let textListInvalidKey = "";
        listInvalidKey.forEach((e, ind) => {
          if (ind == listInvalidKey.length - 1) {
            textListInvalidKey += ` và ${e} `;
          } else {
            textListInvalidKey += ` ${e}, `;
          }
        });
        message.warning(
          `Thiếu thông tin ${textListInvalidKey} ở bản ghi thứ ${index + 1}`,
          4
        );
      }
    });
    return isValid;
  };
  return (
    <Spin spinning={loading}>
      <div className="container">
        <Form form={form}>
          <Row gutter={[16, 8]} style={{marginBottom: 8}}>
            <InputFields data={fields}></InputFields>
          </Row>
        </Form>

        <Row justify={"end"}>
          {!disabled && (
            <Button className="btn-sub" onClick={allocation}>
              Cấp phát thuốc
            </Button>
          )}
        </Row>
      </div>
      <div className="container">
        <TableInputAdd
          scroll={{x: 3000}}
          setData={setData}
          isCheckbox={undefined}
          isPagination={false}
          data={data}
          column={columns}
          disabled={disabled}
        ></TableInputAdd>
      </div>
    </Spin>
  );
};
export default Detail;
